/*
 *  email-autocomplete - 0.1.3
 *  jQuery plugin that displays in-place autocomplete suggestions for email input fields.
 *  
 *
 *  Made by Low Yong Zhen <yz@stargate.io> 
 */
"use strict";

(function ($, window, document, undefined) {
  var pluginName = "emailautocomplete";
  var defaults = {
    suggClass: "eac-sugg",
    domains: ["yahoo.com", "hotmail.com", "gmail.com", "me.com", "aol.com", "mac.com", "live.com", "comcast.net", "googlemail.com", "msn.com", "hotmail.co.uk", "yahoo.co.uk", "facebook.com", "verizon.net", "sbcglobal.net", "att.net", "gmx.com", "outlook.com", "icloud.com"]
  };
  function EmailAutocomplete(elem, options) {
    this.$field = $(elem);
    this.options = $.extend(true, {}, defaults, options); //we want deep extend
    this._defaults = defaults;
    this._domains = this.options.domains;
    this.init();
  }
  EmailAutocomplete.prototype = {
    init: function init() {
      //shim indexOf
      if (!Array.prototype.indexOf) {
        this.doIndexOf();
      }

      //this will be calculated upon keyup
      this.fieldLeftOffset = null;

      //wrap our field
      var $wrap = $("<div class='eac-input-wrap' />").css({
        //display: this.$field.css("display"),
        display: "block",
        position: this.$field.css("position") === 'static' ? 'relative' : this.$field.css("position"),
        fontSize: this.$field.css("fontSize")
      });
      this.$field.wrap($wrap);

      //create container to test width of current val
      this.$cval = $("<span class='eac-cval' />").css({
        visibility: "hidden",
        position: "absolute",
        display: "inline-block",
        fontFamily: this.$field.css("fontFamily"),
        fontWeight: this.$field.css("fontWeight"),
        letterSpacing: this.$field.css("letterSpacing")
      }).insertAfter(this.$field);

      //create the suggestion overlay
      /* touchstart jquery 1.7+ */
      var heightPad = (this.$field.outerHeight(true) - this.$field.height()) / 2; //padding+border
      this.$suggOverlay = $("<span class='" + this.options.suggClass + "' />").css({
        display: "block",
        "box-sizing": "content-box",
        //standardize
        //lineHeight: this.$field.css('lineHeight'),
        lineHeight: "40px",
        //paddingTop: heightPad + "px",
        //paddingBottom: heightPad + "px",
        fontFamily: this.$field.css("fontFamily"),
        fontWeight: this.$field.css("fontWeight"),
        letterSpacing: this.$field.css("letterSpacing"),
        position: "absolute",
        top: 0,
        color: "#63666A",
        left: 0
      }).insertAfter(this.$field);

      //bind events and handlers
      this.$field.on("keyup.eac", $.proxy(this.displaySuggestion, this));
      this.$field.on("blur.eac", $.proxy(this.autocomplete, this));
      this.$field.on("keydown.eac", $.proxy(function (e) {
        if (e.which === 39 || e.which === 9) {
          this.autocomplete();
        }
      }, this));
      this.$suggOverlay.on("mousedown.eac touchstart.eac", $.proxy(this.autocomplete, this));
    },
    suggest: function suggest(str) {
      var str_arr = str.split("@");
      if (str_arr.length > 1) {
        str = str_arr.pop();
        if (!str.length) {
          return "";
        }
      } else {
        return "";
      }
      var match = this._domains.filter(function (domain) {
        return domain.indexOf(str) === 0;
      }).shift() || "";
      return match.replace(str, "");
    },
    autocomplete: function autocomplete() {
      if (typeof this.suggestion === "undefined" || this.suggestion.length < 1) {
        return false;
      }
      this.$field.val(this.val + this.suggestion);
      this.$suggOverlay.text("");
      this.$cval.text("");
    },
    /**
     * Displays the suggestion, handler for field keyup event
     */
    displaySuggestion: function displaySuggestion(e) {
      this.val = this.$field.val();
      this.suggestion = this.suggest(this.val);
      if (!this.suggestion.length) {
        this.$suggOverlay.text("");
      } else {
        e.preventDefault();
      }

      //update with new suggestion
      this.$suggOverlay.text(this.suggestion);
      this.$cval.text(this.val);

      // get input padding, border and margin to offset text
      if (this.fieldLeftOffset === null) {
        this.fieldLeftOffset = (this.$field.outerWidth(true) - this.$field.width()) / 2;
      }

      //find width of current input val so we can offset the suggestion text
      var cvalWidth = this.$cval.width();
      if (this.$field.outerWidth() > cvalWidth) {
        //offset our suggestion container
        this.$suggOverlay.css('left', this.fieldLeftOffset + cvalWidth + "px");
      }
    },
    /**
     * indexof polyfill
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf#Polyfill
    */
    doIndexOf: function doIndexOf() {
      Array.prototype.indexOf = function (searchElement, fromIndex) {
        if (this === undefined || this === null) {
          throw new TypeError('"this" is null or not defined');
        }
        var length = this.length >>> 0; // Hack to convert object.length to a UInt32

        fromIndex = +fromIndex || 0;
        if (Math.abs(fromIndex) === Infinity) {
          fromIndex = 0;
        }
        if (fromIndex < 0) {
          fromIndex += length;
          if (fromIndex < 0) {
            fromIndex = 0;
          }
        }
        for (; fromIndex < length; fromIndex++) {
          if (this[fromIndex] === searchElement) {
            return fromIndex;
          }
        }
        return -1;
      };
    }
  };
  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, "yz_" + pluginName)) {
        $.data(this, "yz_" + pluginName, new EmailAutocomplete(this, options));
      }
    });
  };
})(jQuery, window, document);

/* for wistia page load speed. replace image with wistia video on scroll. */
jQuery(window).on("resize scroll", function () {
  jQuery(".wistia-vid").each(function (index, element) {
    var vid_id = jQuery(this).attr("id");
    jQuery(this).replaceWith('<div class="cf-video-embeded"><script charset="ISO-8859-1" src="//fast.wistia.net/assets/external/E-v1.js" async></script><div class="wistia_responsive_padding" style="padding:56.25% 0 0 0; position:relative;"><div class="wistia_responsive_wrapper" style="height:100%; left:0; position:absolute; top:0; width:100%;"><div class="wistia_embed wistia_async_' + vid_id + ' seo=false videoFoam=true popover=true popoverAnimateThumbnail=true wistia_embed_initialized" style="height:100%; width:100%"></div></div></div></div>');
  });
});

/* for wistia page load speed. replace image with wistia video on scroll. ABOVE THE FOLD */
jQuery(document).on("click", ".wistia-vidplay", function () {
  var vid_id = jQuery(this).attr("id");
  jQuery(this).replaceWith('<div class="cf-video-embeded"><script charset="ISO-8859-1" src="//fast.wistia.net/assets/external/E-v1.js" async></script><div class="wistia_responsive_padding" style="padding:56.25% 0 0 0; position:relative;"><div class="wistia_responsive_wrapper" style="height:100%; left:0; position:absolute; top:0; width:100%;"><div class="wistia_embed wistia_async_' + vid_id + ' seo=false videoFoam=true popover=true popoverAnimateThumbnail=true wistia_embed_initialized" style="height:100%; width:100%"></div></div></div></div><script async>window._wq = window._wq || [];window._wq.push({id: "' + vid_id + '", onReady: function(video){video.play()}});</script>');
});

/* script for opt out shortcode */
jQuery(document).ready(function () {
  var Partner_ID = getSearchParams("Partner_ID");
  var Subscriber_Key = getSearchParams("Subscriber_Key");
  var iframe = document.getElementById("prefIframe");
  if (iframe !== null) {
    iframe.src = "https://mcw7h9jhf1s08kt1t63jsnd2llty.pub.sfmc-content.com/30zedwp4ydi?Partner_ID=";
    var dynamic_src = iframe.src + Partner_ID + "&Subscriber_Key=" + Subscriber_Key;
    iframe.src = dynamic_src;
  }
  httpsReplace();
  removeParentIfChildNotSetValue();
  function getSearchParams(k) {
    var p = {};
    location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) {
      p[k] = v;
    });
    return k ? p[k] : p;
  }

  // Below code used for resolved accessibility issues.   
  jQuery('.mega-menu-link').removeAttr('aria-expanded');
  jQuery('.elementor-search-form__input').attr('aria-label', 'search');
  jQuery('.cf-programs-list .gfield_select').attr('aria-label', 'Program of Interest');
  jQuery('.highest-level .gfield_select').attr('aria-label', 'Highest Level of Education');
  jQuery('.current-emp .gfield_select').attr('aria-label', 'Current Employer');
  jQuery('.gfield_ap_crm_zip input').prop('type', 'tel');
  jQuery('.hear .gfield_select').attr('aria-label', 'how did you hear about us');
  jQuery('.cf-course-group-item .cf-course-group-title').attr('role', 'none');
  jQuery('.cf-courses-accordion-elementor-widget').attr('role', 'none');
  jQuery('.elementor-nav-menu--main').attr('role', 'presentation');
  jQuery('.cf-menu-anchor').attr('title', 'programs');
  jQuery('.cf-menu-anchor').attr('aria-label', 'secondary nav');
  jQuery('.mega-apply-now .mega-menu-link').attr('aria-label', 'Apply Now from header');
  jQuery('.cf-programs-accordion-elementor-widget').attr('role', 'none');
  jQuery('main').attr('aria-label', 'Main Content');
  jQuery('.cf-category-content').attr('role', 'presentation');
  jQuery('.cf-question-title').attr('role', 'none');
  jQuery('.cf-industry-title').attr('role', 'none');
  jQuery('.cf-faq-elementor-widget').attr('role', 'presentation');
  jQuery('.checkbox-copy .gfield_checkbox input').attr('aria-label', 'Select checkbox to agree terms of use');
  jQuery('.w-gallery-view__body button').first().attr('aria-label', 'left school');
  jQuery('.w-gallery-view__body button').next().attr('aria-label', 'right school');
  jQuery('main').attr('id', 'Main');
  jQuery('.landing-page .cf-programs-groups-tab-menu .cf-title').removeAttr('aria-selected');
  jQuery('.landing-page .cf-programs-groups-tab-menu .cf-title').removeAttr('role');
  jQuery('.cf-industry-content .cf-program-title').attr('role', 'none');
  jQuery('.cf-category-title').attr('role', 'none');
  jQuery('form .gform_body ul').attr('role', 'list');
  jQuery('.mid-email-settings iframe').attr('aria-label', 'Iframe for Email Address Change');
  jQuery('.header-top .request-info-btn a').attr('aria-label', 'Request info page link from top header');
  jQuery('.header-top .apply-now-btn a').attr('aria-label', 'Apply Now link from top header');
  jQuery('.header-top .request-info-popup a').attr('aria-label', 'Request info popup from top header');
  jQuery('#breadcrumbs').attr('aria-label', 'Breadcrumb');

  // Mega menu remove current status.
  jQuery('.mega-sub-menu li').removeClass('mega-current-menu-parent');
  jQuery('.mega-sub-menu li').removeClass('mega-current-menu-item');

  /*----------- remove attribute in LP forms added by sunil under kalaivani/chris supervision on 12-14-2023 -----------*/
  /*if (jQuery('body').hasClass('landing-page')) {
    jQuery('.hear [value="Online"]').attr('selected', false);
  }*/

  //jQuery(document).on('click keypress', '.elementor-button, .request-info-popup, .request-info-popup-LP', function () {
  //  //this is we can combine forms - hiding this dropdown on landing pages
  //  if (jQuery('body').hasClass('landing-page')) {
  //    jQuery('.hear [value="Online"]').attr('selected', false);
  //  }
  //});

  //WCAG
  //jQuery(document).on('gform_post_render', function () {
  //  //this is we can combine forms - hiding this dropdown on landing pages
  //  if (jQuery('body').hasClass('landing-page')) {
  //    jQuery('.hear [value="Online"]').attr('selected', false);
  //  }
  //});

  /*------------------ added on 12-14-2023 --------------------*/

  /* Partner Website External ID hidden field */
  jQuery('form .gform_body ul .gfield_ap_crm_partnerwebsiteexternalid').css('display', 'none');

  // skip to content move to header section.
  jQuery('.skip-main').prop('href', './#main');
  jQuery('.skip-main').prependTo('header');

  // This code to used for add or remove active class on Article page.
  jQuery('.article-nav .show-link-parent a').on('click', function () {
    jQuery('.article-nav .show-link-parent a').toggleClass('active');
  });
  addFloatingLabel();

  // Set height for middle section.
  setHeightMiddleSection();

  // Used for search and menu on header section.
  headerSearchBox();
  jQuery('.cf-menu-anchor ul li a').on('click', function () {
    jQuery('.cf-menu-anchor ul li a').removeAttr('aria-current');
    jQuery(this).attr('aria-current', 'true');
  });
  jQuery('.cf-programs-groups-tab-menu ul li a').on('click', function () {
    jQuery('.cf-programs-groups-tab-menu ul li a').removeAttr('aria-current');
    jQuery(this).attr('aria-current', 'true');
  });
  jQuery('.cf-programs-group-elementor-widget ul.vertical li').on('click', function () {
    jQuery('.cf-programs-group-elementor-widget ul.vertical li').attr('aria-expanded', 'false');
    jQuery(this).attr('aria-expanded', 'true');
  });

  // Set javascript:void(0) in primary menu where is not set href for fixed accessibility issues.
  jQuery('.mega-menu-horizontal .mega-menu-flyout.mega-menu-item-has-children').each(function () {
    jQuery(jQuery(this).children()[0]).attr('href', 'javascript:void(0)');
  });

  // Set script for table content on explore page.
  jQuery('.explore .elementor-toc__header').on('click', function () {
    jQuery('.elementor-toc__body').toggle();
    if (jQuery('.elementor-toc__body').css('display') == 'block') {
      jQuery('.elementor-toc__toggle-button--collapse').show();
      jQuery('.elementor-toc__toggle-button--expand').hide();
    } else {
      jQuery('.elementor-toc__toggle-button--expand').show();
      jQuery('.elementor-toc__toggle-button--collapse').hide();
    }
  });
});
jQuery(document).on('gform_post_render', function (e, form_id) {
  addFloatingLabel();
  jQuery('form li.gfield_ap_crm_email input').emailautocomplete();
  jQuery('form li').each(function (index) {
    if (jQuery(this).hasClass('gfield_ap_crm_email')) {
      var myemailinput = jQuery(this).children('div').children('label');
      jQuery(jQuery(this).children('div').children('div').children('input')).insertBefore(myemailinput);
    }
  });
});

/* move the label in the same div as the input in order for float label to work - on validation
jQuery(document).bind('gform_post_render', function(){
  jQuery('.gfield_label').each(function( index ) {
    var forInput = jQuery(this).attr('for');
    jQuery(this).insertAfter('input#' + forInput +', select#' + forInput);
  });
});

jQuery(document).ready(function () {
  jQuery('.ginput_container select').on('change', function() {
    var $this = jQuery(this);
    if ($this.val() != '' && !$this.hasClass('ginput_option_selected')) {
      console.log('add class');
      $this.addClass('ginput_option_selected');
    } else {
      console.log('removeClass');
      $this.removeClass('ginput_option_selected');
    }
  });
});*/

//Scripts for Content Feedback Form
jQuery(document).ready(function () {
  jQuery("a.show-content-feedback-form").click(function (e) {
    e.preventDefault();
    jQuery("#content-feedback-form").show();
  });
});

/*
* Lead Test Magic - DO NOT EDIT
* Also the auto complete functions
*/

var urlParams = new URLSearchParams(window.location.search);
var istestlead = urlParams.get('testlead');
var thecurrentURL = window.location.href;
var thecurrentURL_parts = thecurrentURL.replace(/\/\s*$/, '').split('/');

//carleton forms are loading async
window.addEventListener('load', function () {
  /* FLOATING LABEL FUNCTION */
  addFloatingLabel();
  setHeightMiddleSection();
  headerSearchBox();
  httpsReplace();
  removeParentIfChildNotSetValue();

  // This code is used for replace Weeks to blank. If match word Weeks.
  /*if (jQuery('body').hasClass('program-template-default')) {
    var removeWeeks = jQuery('.cf-course-duration').html().replaceAll('Weeks weeks', 'weeks'); 
    jQuery('.cf-course-duration').html(removeWeeks);
  }*/

  jQuery('.cf-course-duration').text(function (index, text) {
    return text.replace('Weeks', '');
  });
  jQuery('.cf-course-duration').text(function (index, text) {
    return text.replace('Varies weeks', 'Varies');
  });
  jQuery('.cf-course-duration').html(function (i, html) {
    return html.replace(/(Duration):/g, '<b>Duration</b>:');
  });
  jQuery('form li.gfield_ap_crm_email input:visible').emailautocomplete();
  jQuery('.program-anchor .cf-menu-anchor ul li.active a').attr('aria-current', 'true');
  jQuery('.landing-page .cf-programs-groups-tab-menu .cf-title').removeAttr('aria-selected');
  jQuery('.mega-menu-horizontal li.mega-menu-tabbed a').hover(function () {
    jQuery('.mega-menu-horizontal li.mega-menu-tabbed a').attr('aria-expanded', 'false');
    jQuery(this).attr('aria-expanded', 'true');
  });

  // This code is used for Lp pages.
  if (jQuery('body').hasClass('mobile') && jQuery('body').hasClass('landing-page')) {
    if (jQuery('.cf-programs-groups-tab-menu .elementor-tab-title').length === 1) {
      jQuery('.cf-programs-groups-tab-menu .elementor-tab-title').addClass('elementor-active');
      jQuery('.cf-programs-groups-tab-menu .cf-content').show();
      jQuery('.cf-programs-groups-tab-menu .cf-content').addClass('elementor-active');
    } else {
      jQuery('.cf-programs-groups-tab-menu .elementor-tab-title').removeClass('elementor-active');
      jQuery('.cf-programs-groups-tab-menu .elementor-tab-title.initial').removeClass('initial');
      jQuery('.cf-programs-groups-tab-menu .cf-content').removeClass('elementor-active');
    }
  }
}, false);

//apply form on change do the email function
jQuery(document).on('change', '.apply-lead-form .cf-programs-list', function () {
  jQuery('form li.gfield_ap_crm_email input:visible').emailautocomplete();
});

//document ready is only for inline forms and doesn't apply to popups
jQuery(document).ready(function () {
  jQuery('form li.gfield_ap_crm_email input:visible').emailautocomplete();
  if (istestlead === 'true') {
    if (thecurrentURL_parts[3] === 'online') {
      change_form_lead_test('inline', 'lp', 'req');
    } else if (thecurrentURL_parts[3] === 'apply') {
      change_form_lead_test('inline', 'ps', 'apply');
    } else {
      change_form_lead_test('inline', 'ps', 'req');
    }
  }
});
jQuery(document).on("click", ".request-info-popup a, .request-info-popup, .request-info-popup-LP", function () {
  jQuery('form li.gfield_ap_crm_email input').emailautocomplete();
  if (istestlead === 'true') {
    if (thecurrentURL_parts[3] === 'online') {
      change_form_lead_test('pop', 'lp', 'req');
    } else {
      change_form_lead_test('pop', 'ps', 'req');
    }
  }
});
jQuery(document).on("click", ".apply-now-popup", function () {
  jQuery('form li.gfield_ap_crm_email input').emailautocomplete();
  if (istestlead === 'true') {
    if (thecurrentURL_parts[3] === 'online') {
      change_form_lead_test('pop', 'lp', 'apply');
    } else {
      change_form_lead_test('pop', 'ps', 'apply');
    }
  }
});
function change_form_lead_test(form_type, page_type, form_name) {
  if (form_type === 'pop' && form_name === 'req') {
    var add_pop = '.popup-request-info ';
  } else if (form_type === 'pop' && form_name === 'apply') {
    var add_pop = '.apply-lead-form_wrapper ';
  } else {
    var add_pop = '';
  }
  var randomnum = Math.floor(Math.random() * 2000) + 1;
  var frmzipcode = '91007';
  var frmCAzipcode = 'T0G 0Y0';
  // Extract site id from the body tag and append to the phone number
  var bodyClasses = document.body.classList;
  var siteIdClass = Array.from(bodyClasses).find(function (className) {
    return className.startsWith('site-id-');
  });
  var siteId = siteIdClass ? siteIdClass.split('-')[2] : null;
  var staticphone = '972-800-0000';
  if (siteId) {
    var modifiedPhoneNum = staticphone.replace(/(\d{4})$/, siteId.padStart(4, '0'));
  } else {
    var modifiedPhoneNum = staticphone;
  }
  var frmphonenum = modifiedPhoneNum;
  var fullname = 'test' + page_type + form_name + form_type + randomnum;
  var frmemail = 'test' + page_type + form_name + form_type + randomnum + '@' + 'test' + page_type + form_name + form_type + randomnum + '.com';
  jQuery(add_pop + 'form li.gfield_ap_crm_first_name input').each(function () {
    jQuery(this).val(fullname);
  });
  jQuery(add_pop + 'form li.gfield_ap_crm_last_name input').each(function () {
    jQuery(this).val(fullname);
  });
  jQuery(add_pop + 'form li.gfield_ap_crm_phone input').each(function () {
    jQuery(this).val(frmzipcode);
  });
  jQuery(add_pop + 'form li.gfield_ap_crm_zip_international input').each(function () {
    jQuery(this).val(frmCAzipcode);
  });
  jQuery(add_pop + 'form li.gfield_ap_crm_zip input').each(function () {
    jQuery(this).val(frmzipcode);
  });
  jQuery(add_pop + 'form li.gfield_ap_crm_phone input').each(function () {
    jQuery(this).val(frmphonenum);
  });
  jQuery(add_pop + 'form li.gfield_ap_crm_email input').each(function () {
    jQuery(this).val(frmemail);
  });
  jQuery(add_pop + 'form li.gfield_ap_crm_referrer select').each(function () {
    jQuery(this).val('Coworker').change();
  });
  jQuery(add_pop + 'form li.gfield_ap_crm_program select').each(function () {
    var last_option = jQuery('.gfield_ap_crm_program select option:last').val();
    jQuery(this).val(last_option).change();
  });
}

/**
 * Allow custom jQuery to be executed for popup modal request info/apply form (initial form load, form rendered with validation errors, confirmation message displayed, etc.)
 * https://github.com/elementor/elementor/issues/7245#issuecomment-920244300
 */
jQuery(document).on('elementor/popup/show', function (event, id, instance) {
  var gform_wrapper = jQuery('.gform_wrapper', instance.$element);
  if (gform_wrapper.length > 0) {
    var popup_form_id = gform_wrapper.get(0).id.replace(/^gform_wrapper_/, ''); // e.g. id="gform_wrapper_xxx"
    jQuery(document).trigger('gform_post_render', [popup_form_id, 1]);
  }
});
function addFloatingLabel() {
  if (jQuery('.cf-programs-list .gfield_select').find(":selected").val() !== '') {
    jQuery('.cf-programs-list .ginput_container_select .gfield_label').show();
    jQuery('.hear .ginput_container_select .gfield_label').hide();
  } else jQuery('.ginput_container_select .gfield_label').hide();

  //jQuery('form li.gfield_ap_crm_email input').emailautocomplete();
  //for some reason the bind event is not firing in chrome, so added this here for apply page (non ajax form)
  jQuery('form li').each(function (index) {
    //console.log('is ready firing?');
    var mylabel = jQuery(this).children('.gfield_label');
    var myinput = jQuery(this).children('div').children('input');
    var myselect = jQuery(this).children('div').children('select');
    var mytextarea = jQuery(this).children('div').children('textarea');
    jQuery(mylabel).insertAfter(myinput);
    jQuery(mylabel).insertAfter(mytextarea);
    jQuery(mylabel).insertAfter(myselect);

    //email field 
    //var myemailinput = jQuery(this).children('div').children('div').children('input');
    //jQuery(mylabel).insertAfter(myemailinput);

    //email field
    if (jQuery(this).hasClass('gfield_ap_crm_email')) {
      var myemailinput = jQuery(this).children('div').children('label');
      jQuery(jQuery(this).children('div').children('div').children('input')).insertBefore(myemailinput);
    }
  });
}

// Set height for middle section
function setHeightMiddleSection() {
  var header_height = jQuery('.header').height();
  var footer_height = jQuery('footer').height();
  var total_height = header_height + footer_height;
  jQuery('.fixed-height-content').css({
    'min-height': 'calc(100vh - ' + total_height + 'px)'
  });
}

//get the uuid to populate for calendly 
function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
  });
}

// get current date and time to generate a unique as possible UUID for calendly 
function getDateTime() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth() + 1;
  var day = now.getDate();
  var hour = now.getHours();
  var minute = now.getMinutes();
  var second = now.getSeconds();
  if (month.toString().length == 1) {
    month = '0' + month;
  }
  if (day.toString().length == 1) {
    day = '0' + day;
  }
  if (hour.toString().length == 1) {
    hour = '0' + hour;
  }
  if (minute.toString().length == 1) {
    minute = '0' + minute;
  }
  if (second.toString().length == 1) {
    second = '0' + second;
  }
  var dateTime = year + month + day + hour + minute + second;
  return dateTime;
}

//populate the partnerwebsiteexternalid input
jQuery(document).ready(function () {
  var stringPathName = window.location.hostname;
  var partnerwebsiteexternalid = uuidv4() + '-' + stringPathName + '-' + getDateTime();
  //console.log(partnerwebsiteexternalid);
  jQuery('li.gfield_ap_crm_partnerwebsiteexternalid input').val(partnerwebsiteexternalid);
});
jQuery(document).on("click", ".request-info-popup a, .request-info-popup, .request-info-popup-LP", function () {
  var stringPathName = window.location.hostname;
  var partnerwebsiteexternalid = uuidv4() + '-' + stringPathName + '-' + getDateTime();
  //console.log(partnerwebsiteexternalid);
  jQuery('li.gfield_ap_crm_partnerwebsiteexternalid input').val(partnerwebsiteexternalid);
});

// This javascript code is used search box for header section.
function headerSearchBox() {
  //On click replace icon search to go button.
  jQuery('.elementor-search-form__toggle').click(function (event) {
    event.preventDefault();
    if (event.target.className == 'fas fa-search') {
      jQuery('.elementor-search-form__container').show();
    } else {
      jQuery('.elementor-search-form__container').hide();
    }
  });

  // On click on mega menu is open search search box hide.
  jQuery('.mega-toggle-animated').on('click', function () {
    jQuery('.elementor-search-form__toggle i').removeClass('eicon-close').addClass('fas fa-search');
    jQuery('.elementor-search-form__container').removeClass('elementor-search-form--full-screen elementor-lightbox');
  });

  // On click on mega menu is open search search box hide.
  jQuery('.mega-menu-horizontal .mega-menu-link').click(function (event) {
    //console.log('menu clicks');
    jQuery('.elementor-search-form__toggle i').removeClass('eicon-close').addClass('fas fa-search');
    jQuery('.elementor-search-form__container').removeClass('elementor-search-form--full-screen elementor-lightbox');
  });
}

/* Henderson and Ellen need the consent hidden if the lsid = Referral_Field */
jQuery(document).ready(function () {
  var lsid = urlParams.get('lsid');
  if (lsid === 'Referral_Field') {
    jQuery('p.form-consent').hide();
  }
});
jQuery(document).on("click", ".request-info-popup a, .request-info-popup, .request-info-popup-LP", function () {
  var lsid = urlParams.get('lsid');
  if (lsid === 'Referral_Field') {
    jQuery('p.form-consent').hide();
  }
});

// Hiding empty form option fields that contain a CRM code, but no degree name.
jQuery(document).ready(function () {
  jQuery('form option').filter(function () {
    return !this.value || jQuery.trim(this.value).length === 0 || jQuery.trim(this.text).length === 0;
  }).css('display', 'none');
});
function httpsReplace() {
  var svgElements = document.querySelectorAll('svg');

  // Iterate over each SVG element and update its xmlns attribute
  svgElements.forEach(function (svg) {
    if (svg.getAttribute('xmlns') === 'http://www.w3.org/2000/svg') {
      svg.setAttribute('xmlns', 'https://www.w3.org/2000/svg');
    }
    if (svg.getAttribute('xmlns:svg') === 'http://www.w3.org/2000/svg') {
      svg.setAttribute('xmlns:svg', 'https://www.w3.org/2000/svg');
    }
    if (svg.getAttribute('xmlns:xlink') === 'http://www.w3.org/1999/xlink') {
      svg.setAttribute('xmlns:xlink', 'https://www.w3.org/1999/xlink');
    }
  });
  jQuery('a').each(function () {
    var currentHref = jQuery(this).attr('href');
    if (currentHref && currentHref.startsWith('http:')) {
      jQuery(this).attr('href', currentHref.replace('http:', 'https:'));
    }
  });
}

// Function used to remove parent div if chlid value is not set for tokens.
function removeParentIfChildNotSetValue() {
  jQuery(".elementor-widget-cf-program-field .cf-program-elementor-widget .linkbox-left:empty").closest("div.elementor-widget-cf-program-field").remove();
  jQuery('.elementor-widget-cf-program-field .cf-program-elementor-widget').each(function () {
    // Check if the .cf-program-elementor-widget  element has no text or HTML content
    if (jQuery(this).html().trim() === '') {
      // Remove the closest parent .elementor-widget-cf-program-field
      jQuery(this).closest('.elementor-widget-cf-program-field').remove();
    }
  });
}